import {
  CLIENT_CREATION_KEY_API,
  registerClientCreation,
} from "./clientRegister";
import axios, { AxiosInstance } from "axios";

// Hub endpoints are mounted at the API root (`/hub/...`), not under
// `/learn/v3/` — hence a dedicated client rather than learnApiClient.
// eslint-disable-next-line import/no-mutable-exports
export let hubApiClient: AxiosInstance;

const create = (baseURL: string) => {
  hubApiClient = axios.create({
    baseURL: baseURL + "/hub/",
  });

  hubApiClient.interceptors.request.use(
    async (config) => {
      const value = localStorage.getItem("authStore");

      let keys;

      if (value) {
        keys = JSON.parse(value);

        // eslint-disable-next-line no-param-reassign
        config.headers = {
          authorization: `AuthToken token=${keys.state.authConfig.authtoken}`,
        };
      }

      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );
};

registerClientCreation(CLIENT_CREATION_KEY_API, create);
